import { isInvalidPurchaseOrderNumber } from "src/validation/stringValidation";
import { FormValidator } from "../formValidator";
import { ValidationError, ValidationErrors } from "src/errors";
import { ResolveAAErrorFormDataKey } from "src/types/forms/activeAntsPurchaseOrders/resolveAAErrorForm";

class ResolveAAErrorFormValidator extends FormValidator {
  private static validateActiveAntsPurchaseOrderId(
    value: unknown
  ): ValidationError<"activeAntsPurchaseOrderId"> | undefined {
    return isInvalidPurchaseOrderNumber(value)
      ? new ValidationError("Enter a valid AA purchase order id (e.g., 'AA-012345678')", "activeAntsPurchaseOrderId")
      : undefined;
  }

  private static readonly validationStrategies: Record<
    ResolveAAErrorFormDataKey,
    (inputValue: unknown) => ValidationError<ResolveAAErrorFormDataKey> | undefined
  > = {
    activeAntsPurchaseOrderId: ResolveAAErrorFormValidator.validateActiveAntsPurchaseOrderId
  };

  static validateResolveAAErrorFormData<T extends ResolveAAErrorFormDataKey>(
    formData: Partial<Record<T, unknown>>
  ): ValidationErrors<T> {
    return super.validateFormData(formData, ResolveAAErrorFormValidator.validationStrategies) as ValidationErrors<T>;
  }
}

export { ResolveAAErrorFormValidator };
